/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_OrganizeInputs */

const en_pc_cmp_r_organize = /** @type {(inputs: Pc_Cmp_R_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotate, delete, insert and reorder pages`)
};

const zh_pc_cmp_r_organize = /** @type {(inputs: Pc_Cmp_R_OrganizeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旋转、删除、插入与重排页面`)
};

/**
* | output |
* | --- |
* | "Rotate, delete, insert and reorder pages" |
*
* @param {Pc_Cmp_R_OrganizeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_organize = /** @type {((inputs?: Pc_Cmp_R_OrganizeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_OrganizeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_organize(inputs)
	return zh_pc_cmp_r_organize(inputs)
});
export { pc_cmp_r_organize as "pc.cmp.r.organize" }